const o={ConfirmAndGoToNext:"louis/stepWizard/confirmAndGoToNext"},n=()=>({confirmAndGoToNext:()=>{document.dispatchEvent(new CustomEvent(o.ConfirmAndGoToNext))}});export{o as StepWizardEvents,n as useStepWizard};
//# sourceMappingURL=useStepWizard.js.map
